// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
import Original from 'lucide-react/dist/esm/icons/panels-top-left.js';

import { paths } from '../generated/panels-top-left';
import { makeBrandedIcon } from '../make-branded';

export default makeBrandedIcon('panels-top-left', Original, paths);
